import React from 'react';

import groupBy from 'lodash/groupBy';

import ModelDataTable from '../ModelDataTable/ModelDataTable';
import ModelListBlankSlate from './ModelListBlankSlate';

const groupModelsById = (models = []) => groupBy(models, ({ modelID }) => modelID);

export const ModelsList = ({ models = [] }) => {
  const modelLength = models ? models.length : 0;
  const groupedModels = modelLength ? groupModelsById(models) : null;

  return (
    !modelLength ? (
      <ModelListBlankSlate />
    ) : (
      <ModelDataTable modelGroupings={groupedModels} />
    )
  );
}

export default ModelsList;
